<template>
  <div
    class="jdConent"
    v-loading="loading"
    element-loading-text="加载中"
    :key="activeName"
  >
    <el-table
      :data="tableData"
      v-if="
        ['jd_browse', 'produce_jd_qr', 'official_account_qr'].indexOf(
          show_data
        ) > -1
      "
      style="width: 90%"
    >
      <el-table-column
        :prop="item.prop"
        :label="item.label"
        align="center"
        v-for="(item, i) in title[show_data]"
        :key="i"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.children">
            <el-popover placement="right" width="400" trigger="click">
              <el-table :data="scope.row.children" height="400px">
                <el-table-column
                  v-if="show_data == 'jd_browse'"
                  width="60"
                  property="elite_name"
                  label="浏览人"
                ></el-table-column>
                <el-table-column
                  v-if="show_data == 'jd_browse'"
                  property="username"
                  label="账号"
                ></el-table-column>
                <el-table-column
                  property="request_time"
                  label="时间"
                ></el-table-column>
              </el-table>
              <el-button slot="reference" type="warning" size="mini"
                >查看详情</el-button
              >
            </el-popover>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="tableData" v-else style="width: 90%">
      <el-table-column
        :prop="item.prop"
        :label="item.label"
        align="center"
        v-for="(item, i) in title[show_data]"
        :key="i"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";

export default {
  name: "jdConent",
  props: ["activeName", "show_data"],
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      loading: true,
      data: [],
      title: {
        chat_list: [
          { prop: "elite_name", label: "精英姓名" },
          { prop: "chat_time", label: "最近一次聊天时间" },
        ],
        jd_list: [
          { prop: "jd_title", label: "职位名称" },
          { prop: "create_time_str", label: "创建时间" },
          //   { prop: "jd_hide", label: "是否下架" },
        ],
        jd_browse: [
          { prop: "jd_name", label: "职位名称" },
          { prop: "number", label: "浏览次数" },
        ],
        interview_list: [
          { prop: "elite_name", label: "面试人" },
          { prop: "elite_phone", label: "手机" },
          { prop: "interview_time_str", label: "时间" },
        ],
        produce_jd_qr: [
          { prop: "jd_name", label: "生成职位名称" },
          { prop: "number", label: "生成次数" },
        ],
        official_account_qr: [
          { prop: "jd_name", label: "生成职位名称" },
          { prop: "number", label: "生成次数" },
        ],
      },
      tableData: [],
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {
    activeName() {
      this.loading = true;
      this.getData();
    },
    show_data() {
      this.loading = true;
      this.getData();
    },
  },
  //存放方法集合
  methods: {
    handleClick() {
      this.getData();
    },

    getData() {
      let obj = {
        user_detail_id: this.$route.query.id,
        day_week: this.activeName,
        show_data: this.show_data,
      };
      require("POST", "/hr24_index_data/v1/user_data_detail/", obj).then(
        (res) => {
          if (!res.code) {
            this.loading = false;
            this.tableData = res.data;
            if (this.show_data == "jd_browse") {
              this.tableData = res.data[0].jd_list;
            }
            if (this.show_data == "chat_list") {
              this.tableData = res.data[0].elite_list;
            }
            if (this.show_data == "produce_jd_qr") {
              this.tableData = res.data[0];
            }
            if (this.show_data == "official_account_qr") {
              this.tableData = res.data[0];
            }
            // console.log(JSON.parse(res.data));
            // let data_1 = res.data[0].jd_list;
            // let data_2 = res.data[1].date_list;
            // console.log("data1data2", data_1, data_2);
          }
        }
      );
    },
  },
  //数据初始化之后
  created() {},
  //页面渲染之后
  mounted() {
    this.getData();
  },
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {},
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */

.jdConent {
  padding: 60px 20px 20px;
  min-height: 400px;
}

.jdConent > p {
  float: left;
  width: 150px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #fff;
  margin: 0;
  border: #fff solid 2px;
  background: rgb(140, 174, 236);
}
.jdConent .con {
  width: 50%;
  float: left;
  height: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/recruitmentData/jdConent.vue